import type { CSSProperties } from 'react';
import { css, styled } from 'styled-components';

import type { OverlayVariant } from './types';

type ContainerProps = {
  isDisplayed: boolean;
  positionY: number | null;
  positionX: number | null;
  maxWidth?: string;
  minWidth?: string;
  maxHeight: CSSProperties['maxHeight'] | null;
  variant: OverlayVariant;
  disablePortalForOptions?: boolean;
};

const displayedStyles = css<ContainerProps>`
  left: ${({ positionX }) => positionX}px;
  top: ${({ positionY }) => positionY}px;
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth};`}
  ${({ minWidth }) => minWidth && `min-width: ${minWidth};`}
  ${({ variant }) => variant === 'fit-target' && 'width: 100%;'}
  visibility: visible;
  opacity: 1;
`;

const maxHeightStyles = css<ContainerProps>`
  max-height: ${({ maxHeight }) => maxHeight};
  overflow-y: auto;
`;

const Container = styled.div<ContainerProps>`
  display: block;
  position: ${({ disablePortalForOptions }) => (disablePortalForOptions ? 'fixed' : 'absolute')};
  visibility: hidden;
  border-radius: ${({ theme }) => theme.designTokens.overlayRadius};
  box-shadow: ${({ theme }) => theme.designTokens.overlayShadow};
  background: ${({ theme }) => theme.designTokens.overlayBackgroundColor};
  opacity: 0;
  z-index: ${({ theme }) => theme.zIndices.overlay};
  top: -1000px;
  left: -1000px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ maxHeight }) => maxHeight && maxHeightStyles}
  ${({ isDisplayed }) => isDisplayed && displayedStyles}
`;

export const Styled = {
  Container,
};
